module.exports = __webpack_public_path__ + "static/media/EHS-accessible-information-and-communication-policy.be6a5708.pdf";